<template>
    <div>
        <loader :trigger="loading" :message="loaderMessage"></loader>
        <div class="columns" style="width: 99%; margin: auto">
            <div class="column">
                <div class="font-apercu-bold is-size-4">
                    <div
                        class="title"
                        style="font-size: 30px; margin-bottom: 5px"
                    >
                        {{ $t("Send a New Shipment") }}
                    </div>
                </div>
            </div>
        </div>
        <div
            class="columns top-part"
            style="
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding: 10px 20px;
            "
        >
            <div class="column steps-side is-6 py-3">
                <div>
                    <steps ref="stepNav" @changed="stepsChanged"></steps>
                </div>
            </div>
        </div>
        <div style="margin-top: 50px">
            <div class="columns is-centered">
                <div class="column is-12">
                    <div id="main-card">
                        <div id="form-area">
                            <component
                                :is="currentForm"
                                ref="shippingSteps"
                                @clickNextBtn="childClicksNext"
                                @finish="nextState = $event"
                            ></component>
                        </div>
                        <div id="step-navigation-area">
                            <button
                                :disabled="currentForm == 'form1'"
                                class="button back"
                                @click="backStep"
                            >
                                <span>{{ $t("Back") }}</span>
                            </button>
                            <button class="button ActiveNext" @click="nextStep">
                                <span>{{ $t("Next") }}</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue2Filters from "vue2-filters";
import { globalEvent } from "@/main";
import Loader from "@/components/Loader.vue";
import Steps from "@/components/ShippingSteps.vue";
import ShipmentDetails from "@/components/SendShipment/ShipmentDetails.vue";
import Form3 from "@/components/SendShipment/Form3.vue";

export default {
    mixins: [Vue2Filters.mixin],
    components: {
        steps: Steps,
        ShipmentDetails,
        form3: Form3,
        loader: Loader,
    },
    data() {
        return {
            forms: ["shipment-details", "form3"],
            currentForm: "shipment-details",
            finalize: false,
            loading: false,
            loaderMessage: "",
            nextState: false,
        };
    },
    methods: {
        backStep() {
            let x = this.forms.findIndex((s) => {
                return s == this.currentForm;
            });
            if (x == 0) return;
            this.currentForm = this.forms[--x];
            this.$refs.stepNav.clickBack();
        },
        nextStep() {
            if (this.$refs.shippingSteps.allowNext()) {
                window.scrollTo(0, 0);

                if (this.currentForm != this.forms[this.forms.length - 1]) {
                    this.$refs.stepNav.clickNext();
                    this.$refs.shippingSteps.hideForm();

                    let x = this.forms.findIndex((s) => {
                        return s == this.currentForm;
                    });

                    if (x < this.forms.length - 1) {
                        this.currentForm = this.forms[++x];
                    }
                } else {
                    this.checkout();
                }
            }
        },
        childClicksNext() {
            this.nextStep();
        },
        stepsChanged(event) {
            let x = this.forms.findIndex((s) => {
                return s == this.currentForm;
            });
            if (x > event) {
                this.currentForm = this.forms[event];
            }
        },
        checkout() {
            if (this.shipment_id) {
                this.$store.dispatch("UPDATE_SHIPMENT").then((id) => {
                    this.$router.push(`/checkout/${id}`);
                });
                return;
            }
            this.$store.dispatch("shipment").then((id) => {
                this.$router.push(`/checkout/${id}`);
            });
        },
    },
    computed: {
        shipment_id() {
            return this.$store.getters.shipment_id;
        },
        userData() {
            return this.$store.getters.userData;
        },
    },
    created() {
        globalEvent.$on("steps", (s) => {
            this.currentForm = this.forms[s];
        });

        globalEvent.$on("finalize", () => {
            this.finalize = true;
        });
    },
    mounted() {
        this.loading = true;
        this.$store.dispatch("userData").then(() => {
            this.loading = false;
        });
    },
};
</script>

<style lang="scss">
.footer {
    background: none !important;
}

.py-3 {
    padding: 30px 0;
}

.balance {
    background: #fafafa;
    color: #000;
    padding: 15px 10px;
    width: 300px;
    border-radius: 15px;
    font-size: 16px !important;
    display: flex;
    justify-content: space-between;
    align-items: center;

    span {
        padding: 5px;
        font-size: 26px;
        font-weight: bold;
    }

    img {
        width: 100px;
    }
}

#main-card {
    background: white !important;
    min-width: 40%;
    min-height: 375px;
    width: 100%;
    height: 100%;

    .btn-disabled {
        border: 1px solid #686868 !important;
    }

    #step-navigation-area {
        display: flex;
        justify-content: space-between;

        padding: 20px;

        button {
            display: inline-block;
            padding-bottom: calc(0.375em - 1px);
            padding-left: 0.45em;
            padding-right: 0.45em;
            padding-top: calc(0.375em - 1px);
            height: 2.25em;
            border-radius: 5px !important;
            border: none;
        }

        .ActiveNext {
            // background-image: linear-gradient(to right, #6174eb, #3123ae);
            background: #000;
            // #4952ff
            color: white;
        }

        .back {
            background: #f2f2f2;
        }
    }

    #form-area {
        min-height: 300px;
    }
}

@media screen and (max-width: 800px) {
    button {
        font-size: 12px !important;
    }

    .ActiveNext,
    .back,
    .later {
        font-size: 14px !important;
    }

    .title {
        font-size: 24px !important;
    }

    span.font-apercu {
        font-size: 14px !important;
    }

    .top-part {
        flex-wrap: wrap;

        .steps-side {
            width: 95%;
            margin: auto;
        }

        .balance {
            width: 95%;
            margin: auto;
        }
    }
}
</style>
